import { createSlice } from "@reduxjs/toolkit"

export const orderListSlice = createSlice({
	name: "order_list",
	initialState: {
		orders: "",
		errors: [],
	},

	reducers: {
        getOrders: (state, action) => {
			state.orders = action.payload
		},
		getOrdersList: (state, action) => {
			state.orders = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getOrders, getOrdersList, getErrors} = orderListSlice.actions

export default orderListSlice.reducer
